import { Link } from 'react-router-dom';

export default function AcademyArticle({ article }) {
  return <article className="academy-article">
    <header><h1>{article.title}</h1>{article.intro && <p className="lead">{article.intro}</p>}</header>
    {(article.sections || []).map((section) => <section key={section.heading} className="academy-section">
      <h2>{section.heading}</h2>
      {(section.paragraphs || []).map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
      {section.list && <ul>{section.list.map((item) => <li key={item}>{item}</li>)}</ul>}
      {section.steps && <ol>{section.steps.map((item) => <li key={item}>{item}</li>)}</ol>}
      {section.links && <div className="d-flex flex-wrap gap-2">{section.links.map(([to, label]) => <Link key={to} to={to}>{label}</Link>)}</div>}
    </section>)}
  </article>;
}
